export const INITIAL_REQUIREMENT_FIELDS = [
    {
        category: "period",
        prompt: "리서치 대상 기간",
        customPlaceholder: "예: 2020년 이후",
        options: [
            { id: "recent_3y", label: "최근 3년", description: "최신 트렌드 중심으로 3년 범위를 조사합니다." },
            { id: "recent_5y", label: "최근 5년", description: "중기 흐름을 포함해 5년 범위를 조사합니다." },
            { id: "all_time", label: "기간 제한 없음", description: "연도 제한 없이 대표 연구를 폭넓게 포함합니다." },
            { id: "other", label: "직접 입력", description: "원하는 조건을 자유롭게 입력합니다." },
        ],
    },
    {
        category: "scope",
        prompt: "분석 범위",
        customPlaceholder: "예: 벤치마크 성능 비교와 재현성 이슈 중심",
        options: [
            {
                id: "method_and_limit",
                label: "핵심 방법론 + 한계",
                description: "주요 접근법과 한계를 함께 정리합니다.",
            },
            { id: "comparison", label: "접근법 비교 중심", description: "방법론 간 장단점 비교에 집중합니다." },
            { id: "trend", label: "연구 동향 중심", description: "시간 흐름에 따른 연구 변화를 중심으로 정리합니다." },
            { id: "other", label: "직접 입력", description: "원하는 조건을 자유롭게 입력합니다." },
        ],
    },
    {
        category: "language",
        prompt: "검토 문헌 언어 범위",
        customPlaceholder: "예: 영문 80% + 국문 20%",
        options: [
            { id: "mixed", label: "국문+영문 혼합", description: "국내외 문헌을 함께 조사합니다." },
            { id: "korean", label: "국문 우선", description: "국내 문헌 중심으로 조사합니다." },
            { id: "english", label: "영문 우선", description: "국제 저널/학회 논문 중심으로 조사합니다." },
            { id: "other", label: "직접 입력", description: "원하는 조건을 자유롭게 입력합니다." },
        ],
    },
    {
        category: "evidence",
        prompt: "근거 문헌 우선순위",
        customPlaceholder: "예: top-tier conference + 최신 웹 검색 자료 보조",
        options: [
            {
                id: "peer_reviewed",
                label: "Peer-reviewed 우선",
                description: "저널/학회 중심으로 신뢰도 높은 문헌을 우선합니다.",
            },
            { id: "survey_priority", label: "Survey/Review 포함", description: "정리 논문을 적극 포함합니다." },
            { id: "broad", label: "폭넓게 수집", description: "워크숍/프리프린트까지 포함해 폭넓게 수집합니다." },
            { id: "other", label: "직접 입력", description: "원하는 조건을 자유롭게 입력합니다." },
        ],
    },
    {
        category: "output_style",
        prompt: "최종 리포트 스타일",
        customPlaceholder: "예: 기술적 깊이 높은 비판 분석 + 실무 시사점",
        options: [
            {
                id: "balanced",
                label: "요약 + 비판 균형",
                description: "핵심 요약과 비판적 논의를 균형 있게 제공합니다.",
            },
            {
                id: "summary_first",
                label: "요약 중심",
                description: "빠르게 핵심 파악이 가능하도록 요약 중심으로 작성합니다.",
            },
            { id: "critical_first", label: "비판 분석 중심", description: "한계, 공백, 향후 과제 분석에 집중합니다." },
            { id: "other", label: "직접 입력", description: "원하는 조건을 자유롭게 입력합니다." },
        ],
    },
];

export const STEP_ORDER = ["request", "planning", "result"];

export const SOURCE_LABEL_MAP = {
    scienceon: "ScienceON",
    google_scholar: "Google Scholar",
};

export const buildDefaultInitialSelections = () =>
    INITIAL_REQUIREMENT_FIELDS.reduce((acc, field) => {
        const firstOption = field.options[0];
        acc[field.category] = firstOption?.id || "";
        return acc;
    }, {});

export const resolveInitialRequirements = (initialSelections, initialCustomInputs) => {
    const resolved = {};
    for (const field of INITIAL_REQUIREMENT_FIELDS) {
        const selectedOptionId = initialSelections[field.category];
        const selectedOption = field.options.find((option) => option.id === selectedOptionId) || field.options[0];
        const selectedValue =
            selectedOption?.id === "other"
                ? (initialCustomInputs[field.category] || "").trim()
                : selectedOption?.label || "";
        if (!selectedValue) {
            return null;
        }
        resolved[field.category] = selectedValue;
    }
    return resolved;
};
